import React from "react";
import { FormattedMessage } from "react-intl";

import ClientUserModal from "../../app/clientUserModal";
import TableHeader from "../../app/generic/tableHeader";
import TooltipButton from "../../app/generic/tooltipButton";

const UserListHeader = ({ admin, onNewUserClick, onAddUserClick }) => (
  <TableHeader
    equal
    title={
      <FormattedMessage id="user.list" defaultMessage="Seznam uživatelů" />
    }
    left={<ClientUserModal />}
    right={
      <>
        <TooltipButton
          icon="plus"
          disabled={!admin}
          onClick={onAddUserClick}
          className="header-button-margin"
          title={
            <FormattedMessage
              id="user.add.title"
              defaultMessage="Přidání stávajícího uživatele"
            />
          }
          text={
            <FormattedMessage id="user.add" defaultMessage="Přidat uživatele" />
          }
        />
        <TooltipButton
          icon="plus"
          disabled={!admin}
          onClick={onNewUserClick}
          title={
            <FormattedMessage
              id="user.createNew"
              defaultMessage="Vytvoření nového uživatele"
            />
          }
          text={
            <FormattedMessage id="user.new" defaultMessage="Nový uživatel" />
          }
        />
      </>
    }
  />
);

export default UserListHeader;
